<template>
  <a-modal title="护理评价详情" :width="900" :visible="visible" @cancel="handleCancel" :footer="null">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="10" :sm="24">
            <a-form-item label="护士姓名" :labelCol="{xs: { span: 24 },sm: { span: 6 }}" 
              :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}">
              <span>{{ this.record.regDoctorname }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="10" :sm="24">
            <a-form-item label="护士服务" :labelCol="{xs: { span: 24 },sm: { span: 6 }}" :colon="false"
              :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}">
              <span style="margin-right: 10px;">{{ Number(commentLevel)*2 }} 分</span> 
              <a-rate v-model="commentLevel" :star="10" disabled allow-half style="color: #00b88b;" ></a-rate>
              <span class="ant-rate-text">{{ commentLevel == 5 ? '非常满意' : commentLevel == 4 ? '满意' : commentLevel == 3 ?
              '一般' : commentLevel == 2 ? '差' : commentLevel == 1 ? '非常差' :'未评价' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="24" :sm="24">
            <div style="display: flex; margin-bottom: 24px; font-weight: 600; font-size: 13px; color: #666 ;margin-left: 16px;">
              <span>{{ this.record.comment }}</span>
            </div>
                
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="24" :sm="24">
            <div style="display: flex; margin-bottom: 24px;margin-left: 16px;">
              <div  v-for="(item,index) in listItem" :key="index" :class="item.checked?'list-row-wrap active':'list-row-wrap inActive'">
                  <span>{{ item.label }}</span>
              </div>
            </div>
                
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="10" :sm="24">
            <a-form-item label="服务流程" :labelCol="{xs: { span: 24 },sm: { span: 6 }}" :colon="false"
              :wrapperCol="{ xs: { span: 24 },sm: { span: 18 }}">
              <span style="margin-right: 10px;">{{ Number(processScore)*2 }} 分</span> 
              <a-rate v-model="processScore" :star="10" disabled allow-half  style="color: #00b88b;" ></a-rate>
              <span class="ant-rate-text">{{ processScore == 5 ? '非常满意' : processScore == 4 ? '满意' : processScore == 3 ?
              '一般' :
              processScore
              ==
              2 ? '差' : processScore == 1 ? '非常差' :'未评价' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="10" :sm="24">
            <a-form-item label="服务态度" :labelCol="{xs: { span: 24 },sm: { span: 6 }}" :colon="false"
              :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}">
              <span style="margin-right: 10px;">{{ Number(deliverScore)*2 }} 分</span> 
              <a-rate v-model="deliverScore" :star="10" disabled allow-half  style="color: #00b88b;" ></a-rate>
              <span class="ant-rate-text">{{ deliverScore == 5 ? '非常满意' : deliverScore == 4 ? '满意' : deliverScore == 3 ?
                          '一般' :
                          deliverScore
                          ==
              2 ? '差' : deliverScore == 1 ? '非常差' :'未评价' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="10" :sm="24">
            <a-form-item label="评价人" :labelCol="{xs: { span: 24 },sm: { span: 6 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 18 }}">
              <span>{{ this.record.username }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  // import { viewRegisterCommentList } from '@/api/modular/interhospital/viewregistercomment/viewRegisterCommentManage'
  export default {
    data () {
      return {
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        commentLevel: 5,
        processScore : 5,
        deliverScore : 5,
        record : {},
        listItem: [
          {
            label: '专业性强',
            checked: false,
          },
          {
            label: '服务态度好',
            checked: false,
          },
          {
            label: '解决了问题',
            checked: false,
          },
          {
            label: '速度快',
            checked: false,
          },
          {
            label: '按时到达',
            checked: false,
          },
          {
            label: '护理效果棒',
            checked: false,
          },
          {
            label: '准备很齐全',
            checked: false,
          },
        ]
      }
    },
    methods: {
      // 初始化方法
      add(record) {
        this.commentLevel = record.commentLevel / 2;
        this.processScore = record.processScore / 2;
        this.deliverScore = record.deliverScore / 2;
        this.listItem = JSON.parse(record.commentDesc);
        this.record = record;
        this.visible = true
      },
      /**
       * 提交表单
       */
     
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      },
    }
  }
</script>
<style lang="less" scoped>

.list-row-wrap {
    width: 90PX;
    height: 22PX;
    line-height: 22PX;
    border-radius: 22px;
    text-align: center;
    font-size: 13PX;
    font-weight: 400;
    margin-right: 10px;
  }

  .inActive {
    background: #f2f2f2;
    color: #666 ;
  }

  .active {
    background: #06B48D;
    color: #fff ;

  }
.ant-rate-text{
  font-weight: 600;
}
</style>
